import React from "react";
import { useDevLogBi } from "./../../ricos-context";
const BiContext = React.createContext(null);
const BiContextProvider = ({
  children,
  biLogger
}) => {
  return /* @__PURE__ */ React.createElement(BiContext.Provider, { value: React.useMemo(() => ({ biLogger }), [biLogger]) }, children);
};
const useBiNext = (params) => {
  const devLogBi = useDevLogBi();
  if (devLogBi) {
    return (params2) => devLogBi({ ...params, ...params2 });
  }
  return useDebouncedLogBi(params);
};
const useDebouncedLogBi = (params, delay = 500) => {
  const { biLogger } = React.useContext(BiContext) ?? {};
  const timeoutsRef = React.useRef(/* @__PURE__ */ new Map());
  return React.useCallback(
    ({ dataHook, value }) => {
      if (!dataHook || !biLogger) {
        return;
      }
      if (timeoutsRef.current.has(dataHook)) {
        clearTimeout(timeoutsRef.current.get(dataHook));
      }
      const timeout = setTimeout(() => {
        biLogger.logV2?.({
          element_id: dataHook,
          value: value?.toString(),
          plugin_id: params?.pluginId,
          modal_id: params?.modalId,
          node_id: params?.nodeId
        });
        timeoutsRef.current.delete(dataHook);
      }, delay);
      timeoutsRef.current.set(dataHook, timeout);
    },
    [biLogger, delay, params?.pluginId, params?.modalId]
  );
};
export {
  BiContextProvider,
  useBiNext
};
//# sourceMappingURL=bi-context-provider.js.map
